export default {
    state: {
        permissions: [],
        permission: [],
        permission_id: null,
        url: '/api/hms/users/permission',
        errors: {},
        table: {
            fields: [
                {key: 'code', label: 'Code', sortable: true, tdClass: ''},
                {key: 'name', label: 'Name', sortable: true, tdClass: ''},
                {key: 'updated_at', label: 'updated_at', tdClass: ''},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        form: {
            name: '',
        },
    },

    getters: {
        getPermissionTableFields: state => state.table.fields,

        getPermissionsMeta: state => state.meta,

        getPermissionForm: state => state.form,

        getPermissionErrors: state => state.errors,

        getPermissions: state => state.permissions,
    },

    mutations: {
        setPermissions: (state, payload) => {
            state.permissions = payload;
        },

        setPermission: (state, payload) => {
            state.permission_id = payload.permission_id;
            state.permission = payload;
        },

        setPermissionsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setPermissionErrors: (state, payload) => {
            state.errors = payload;
        },

        setPermissionForm: state => {
            state.form = {
                name: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchPermissions: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const permissions = {
                "data": [
                    {
                        "permission_id": 1,
                        "label": "Permission1",
                        "data": {
                            "type": "Permission",
                            "attributes": {
                                "code": "PER000001",
                                "name": "Permission1",
                                "updated_at": "12-09-12",
                            }
                        },
                        "links": {"self": "permissions\/1"}
                    },
                    {
                        "permission_id": 2,
                        "label": "Permission2",
                        "data": {
                            "type": "Permission",
                            "attributes": {
                                "code": "PER000002",
                                "name": "Permission2",
                                "updated_at": "12-10-12",
                            }
                        },
                        "links": {"self": "permissions\/2"}
                    },
                    {
                        "permission_id": 3,
                        "label": "Permission3",
                        "data": {
                            "type": "Permission",
                            "attributes": {
                                "code": "PER000003",
                                "name": "Permission3",
                                "updated_at": "12-12-12",
                            }
                        },
                        "links": {"self": "permissions\/3"}
                    }
                ],
                "links": {
                    "self": "\/permissions",
                    "first": "http:\/\/pilot.test\/api\/ehms\/users\/permissions?page=1",
                    "last": "http:\/\/pilot.test\/api\/ehms\/users\/permissions?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/ehms\/users\/permissions?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/ehms\/users\/permissions",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setPermissions', permissions);

                commit('setPermissionsMeta', permissions.meta);

                resolve(permissions);
            });
        },

        fetchEditPermission: ({state, commit}, permission_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + permission_id + '/edit')
                    .then(response => {
                        state.permission_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitPermission: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setPermissionErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updatePermission: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.permission_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setPermissionErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deletePermission: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.permission_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
